// LoadingScreen.js
import { useState, useEffect } from "react";
import "./LoadingScreen.css";

export default function LoadingScreen() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loading screen after 3 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className={`loadingScreen ${!isLoading ? 'loadingScreen--hidden' : ''}`}>
      <div className="loadingScreen__content">
        {/* Loading Circle */}
        <div className="loadingScreen__circle">
          <svg className="loadingScreen__circleSvg" viewBox="0 0 200 200">
            <circle
              className="loadingScreen__circleTrack"
              cx="100"
              cy="100"
              r="90"
              fill="none"
              strokeWidth="8"
            />
            <circle
              className="loadingScreen__circleProgress"
              cx="100"
              cy="100"
              r="90"
              fill="none"
              strokeWidth="8"
              strokeLinecap="round"
            />
          </svg>

          {/* Logo */}
          <div className="loadingScreen__logo">
            <img src="/brand/logo.png" alt="Terhal Logo" />
          </div>
        </div>

        {/* Loading Text */}
        <div className="loadingScreen__text">
          <div className="loadingScreen__dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}